<template>
    <Card paddingSize="medium">
        <template #content>
            <div class="flex items-center gap-2">
                <div class="rounded-full bg-blue-50 p-1">
                    <Icon
                        :name="iconName"
                        class="w-4 h-4 text-primary"
                    />
                </div>
                <span class="text-gray-700">
                    <slot />
                </span>
            </div>
        </template>
    </Card>
</template>

<script setup lang="ts">
    import Card from '@/Shared/Component/Card.vue'
    import Icon from '@/Shared/Component/Icon.vue'

    const props = defineProps({
        iconName: {
            type: String,
            required: true,
        },
    })
</script>
